import {recommendationActionTypes} from "../constants/ActionTypes";

const initialState = {
  recommendation: null,
};

const recommendation = (state = initialState, action) => {
  switch (action.type) {
    case recommendationActionTypes.GET_RECOMENDATION:
      return {
        ...state,
        recommendation: action.recommendation,
      };
  }
  return state;
};

export default recommendation;



// WEBPACK FOOTER //
// ./reducers/recommendation.reducers.js